export const courses = [
  {
    id: "1",
    title: "경매 입문 클래스",
    description: "경매의 기본 개념부터 실제 입찰까지, 처음 시작하는 분들을 위한 완벽 가이드",
    price: 0,
    type: "무료",
    level: "입문",
    learningMode: ["온라인 VOD"],
    learningSummary: "100% 온라인 · 자유 수강",
    thumbnail: "https://img.echotwin.kr/kangstudy/df8daf51cc6a2c76.jpg",
    lectureCount: 12,
    duration: "총 6시간",
    students: 2340,
  },
  {
    id: "2",
    title: "권리분석 마스터 과정",
    description: "등기부등본 읽는 법부터 말소기준권리, 배당순위까지 권리분석의 모든 것",
    price: 350000,
    type: "유료",
    level: "실전",
    learningMode: ["온라인 VOD", "오프라인 현장실습"],
    learningSummary: "온라인 80% + 오프라인 실습 2회",
    thumbnail: "https://img.echotwin.kr/kangstudy/6da44ce48c49cde9.jpg",
    lectureCount: 16,
    duration: "총 10시간",
    students: 1250,
  },
  {
    id: "3",
    title: "입찰가 산정 실전반",
    description: "수익률 계산부터 적정 입찰가 도출까지, 실제 사례로 배우는 입찰 전략",
    price: 450000,
    type: "유료",
    level: "실전",
    learningMode: ["온라인 VOD", "오프라인 현장실습"],
    learningSummary: "온라인 70% + 오프라인 실습 3회",
    thumbnail: "https://img.echotwin.kr/kangstudy/f666a07d98356209.jpg",
    lectureCount: 10,
    duration: "총 8시간",
    students: 890,
  },
  {
    id: "4",
    title: "명도실무 완전정복",
    description: "임차인 대응부터 명도소송, 집행까지 실제 사례 중심으로 배우는 명도 실무",
    price: 300000,
    type: "유료",
    level: "실전",
    learningMode: ["온라인 VOD"],
    learningSummary: "100% 온라인 · 사례 기반 학습",
    thumbnail: "https://img.echotwin.kr/kangstudy/74bd317d5bd98fdb.jpg",
    lectureCount: 8,
    duration: "총 5시간",
    students: 670,
  },
  {
    id: "5",
    title: "매매사업자 실전 과정",
    description: "매매사업자를 위한 세무, 자금조달, 물건선정 전략까지 A to Z",
    price: 550000,
    type: "실전",
    level: "마스터",
    learningMode: ["온라인 VOD", "오프라인 현장실습"],
    learningSummary: "온라인 60% + 오프라인 실습 5회 + 1:1 코칭",
    thumbnail: "https://img.echotwin.kr/kangstudy/4e56c0c27cd3185e.jpg",
    lectureCount: 20,
    duration: "총 15시간",
    students: 430,
  },
  {
    id: "6",
    title: "오프라인 특강 - 경매현장답사",
    description: "실제 법원 경매 현장을 방문하여 배우는 실전 경매 노하우",
    price: 200000,
    type: "오프라인",
    level: "실전",
    learningMode: ["오프라인 현장실습"],
    learningSummary: "100% 오프라인 · 현장 답사中心",
    thumbnail: "https://img.echotwin.kr/kangstudy/39b730863fb97101.jpg",
    lectureCount: 4,
    duration: "총 2일",
    students: 310,
  },
];